import { keyframes } from 'styled-components';

export const floatA = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(6rem, 4rem) scale(1.12); }
`;

export const floatB = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-7rem, -3rem) scale(1.08); }
`;

export const drift = keyframes`
  from { background-position: 0 0, 0 0; }
  to { background-position: 6.4rem 6.4rem, 6.4rem 6.4rem; }
`;

export const rise = keyframes`
  from { opacity: 0; transform: translateY(2.4rem); }
  to { opacity: 1; transform: none; }
`;

export const gradientShift = keyframes`
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
`;

export const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
`;

export const ping = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  100% { transform: scale(1.9); opacity: 0; }
`;

export const sheen = keyframes`
  0% { transform: translateX(-120%) skewX(-20deg); }
  60%, 100% { transform: translateX(260%) skewX(-20deg); }
`;
